import { ReactElement } from 'react';
import { Skeleton } from 'newcomponents/UI/Skeleton';

export const TeamInfoSkeleton = (): ReactElement => {
  return (
    <>
      <div className="match-stat-wrapper__tab-row__title__icon">
        <Skeleton.Button
          active
          className="match-stat-wrapper__tab-row__skeleton-circle"
        />
      </div>

      <Skeleton.Button
        active
        className="match-stat-wrapper__tab-row__skeleton-lg"
      />
    </>
  );
};
